import React from 'react';
import PlatformChips from '../PlatformChips';
import { platformLabel, compact } from '../soundstatsHelpers';

// Playlists featuring the artist (current placements).

function PlaylistCard({ it, platformKey }) {
  const pl = it.playlist || {};
  const song = it.song || {};
  const subs = pl.latestSubscriberCount != null ? `${compact(pl.latestSubscriberCount)} followers` : '';
  const tracks = pl.latestTrackCount != null ? `${pl.latestTrackCount} tracks` : '';
  const meta = [platformLabel(platformKey || pl.platform), subs, tracks, pl.countryCode].filter(Boolean).join(' · ');
  return (
    <div className="ss-pl-card">
      {pl.imageUrl && <img className="ss-pl-img" src={pl.imageUrl} alt="" loading="lazy" />}
      <div className="ss-pl-body">
        <div className="ss-pl-name">{pl.name || '—'} <span className="ss-tag">{pl.type || 'playlist'}</span></div>
        <div className="ss-pl-meta">{meta}</div>
        <div className="ss-pl-song">Feat. <b>{song.name || '—'}</b> · #{it.position}</div>
      </div>
    </div>
  );
}

export default function PlaylistsGroup({ platforms, entries, chipIdx, setChipIdx }) {
  let cards;
  if (chipIdx === 0) {
    const all = [];
    platforms.forEach(e => (e.items || []).forEach(it => all.push({ it, key: e.key })));
    all.sort((a, b) => (a.it.position || 9999) - (b.it.position || 9999));
    cards = all.slice(0, 60).map((o, i) => <PlaylistCard key={i} it={o.it} platformKey={o.key} />);
  } else {
    const entry = entries[chipIdx];
    const items = entry ? entry.items.slice().sort((a, b) => (a.position || 9999) - (b.position || 9999)).slice(0, 40) : [];
    cards = items.map((it, i) => <PlaylistCard key={i} it={it} platformKey={entry.key} />);
  }

  return (
    <>
      <div className="ss-content-title"><h2>Playlists</h2><span className="ss-sec-hint">Playlists featuring this artist</span></div>
      <PlatformChips entries={entries} idx={chipIdx} onPick={setChipIdx} />
      <div className="ss-pl-grid">{cards.length ? cards : <div className="ss-empty">No playlists</div>}</div>
    </>
  );
}
